import { useQuery } from "@tanstack/react-query";
import { axiosCompanyInstance } from "src/config/axios";
import { CustomerModel } from "../types/Customer";

export const RQ_CUSTOMER_DETAILS_KEY = "CUSTOMER_DETAILS_KEY";

export type CustomerDetailsResponse = CustomerModel;

export const useCustomerDetails = (customerId: string) => {
    return useQuery({
        queryKey: [RQ_CUSTOMER_DETAILS_KEY, customerId],
        queryFn: async (): Promise<CustomerDetailsResponse | null> => {
            if (customerId) {
                const res = await axiosCompanyInstance.get(`customer/${customerId}`);

                return res?.data || null;
            }
            return null;
        },
        enabled: false,
    });
};
